import React, {useEffect, useState} from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Button,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Text,
    CloseButton,
    Box, Flex, VStack, HStack, Link, PinInput, PinInputField, useToast,
} from "@chakra-ui/react";
import {handleCheckVerificationCode} from "../../../utils/auth-helpers";
import {useAuth} from "../../../redux/AuthProvider";
import {useTranslation} from "react-i18next";
import {useServerIP} from "../../../redux/ServerIPContext";

const SignInScreen2 = ({ isOpen, onClose, email }) => {
    const toast = useToast();
    const [verificationCode, setVerificationCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const auth = useAuth();
    const {t} = useTranslation();
    const { serverIPs, setServerIPs, isDev } = useServerIP();

    const checkVerificationCode = async () => {
        setIsLoading(true)
        await handleCheckVerificationCode(email.toString().toLowerCase(), verificationCode.split('').join(' '), "signin", serverIPs.SERVER_IP).then((response) => {
            setIsLoading(false)
            if (response === null) {
                toast({
                    title: t("Oops, something went wrong. Please try again."),
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                })
            } else if (response.status === 401) {
                toast({
                    title: t("Incorrect verification code. Please try again."),
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                })
            } else if (response.status === 200) {
                //set local storage userID equal to response.userID
                localStorage.setItem('email', response.email.toString());
                localStorage.setItem('firstName', response.firstName.toString());
                localStorage.setItem('lastName', response.lastName.toString());
                auth.login(response.userID);
                auth.setIsLoggedIn(true);
                setVerificationCode('')
                onClose();
            }
        });
    };

    useEffect(() => {
        if (verificationCode.length === 5) {
            checkVerificationCode().then(r => {});
        }
    }, [verificationCode]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
            <ModalOverlay />
            <ModalContent borderRadius="1rem" p="0.75rem" h="30.5rem" w="26rem" overflowY="auto" position="relative">
                <Box
                    position="absolute"
                    top="10px"
                    right="10px"
                    zIndex={999}
                >
                    <CloseButton
                        size="md"
                        onClick={onClose}
                        bg="transparent"
                        borderRadius="50%"
                        _hover={{
                            bg: "gray.200",
                            borderRadius: "50%",
                        }}
                    />
                </Box>
                <Flex alignItems="center" justifyContent="space-between" p={4} >
                    <VStack align="center" width={'100%'} spacing={4}>
                        <Text fontSize="xl" fontWeight="bold">{t("Enter Verification Code")}</Text>
                        <Box w={'full'} h={'1px'} bg={'gray.300'} />
                        <VStack align="center" width={'100%'} spacing={3}>
                            <Text fontSize="sm" fontWeight="normal" textAlign={"center"}>{t("check your email:")} {email}</Text>
                            <Text fontSize="xs" fontWeight="normal" textAlign={"center"}>{t("(it might be in spam)")}</Text>
                        </VStack>
                    </VStack>
                </Flex>
                <ModalBody>
                    <Stack spacing={4}>
                        <HStack my={'3rem'} justifyContent={'center'}>
                            <PinInput size='lg' autoFocus={true} value={verificationCode} onChange={(value)=>{
                                setVerificationCode(value);
                            }}>
                                <PinInputField />
                                <PinInputField />
                                <PinInputField />
                                <PinInputField />
                                <PinInputField />
                            </PinInput>
                        </HStack>
                        <Stack spacing={10} pt={2}>
                            <Button
                                borderRadius={16}
                                colorScheme={'orange'}
                                bgGradient="linear(to-r, orange.400, orange.500)"
                                _hover={{
                                    bgGradient: "linear(to-r, orange.400, orange.600)",
                                    boxShadow: 'lg'
                                }}
                                onClick={() => {
                                    checkVerificationCode().then(r => {});
                                }}
                                loadingText="Submitting"
                                isLoading={isLoading}
                                size="lg">
                                {t("Submit")}
                            </Button>
                        </Stack>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default SignInScreen2;
